(function() {
    'use strict';
    /*
     * Copyright (c) 2015-2017 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .controller('ihh.common-web.ViewEditPersonCtrl', ViewEditPersonCtrl);

    ViewEditPersonCtrl.$inject = ['$scope', 'IhhMedia', 'Utilities', 'Roles', 'RestResources'];

    function ViewEditPersonCtrl($scope, IhhMedia, Utilities, Roles, RestResources) {
        $scope.personCategory = $scope.personCategory || 'Person';

        $scope.showActive = !! $scope.getActive;

        $scope.roles = Roles[$scope.roleType];

        $scope.formatActive = function(active) {
            return active ? 'Active' : 'Inactive';
        };

        $scope.isThumbnailSet = function() {
            return $scope.editFlag ? $scope.thumbnailContainer.thumbnail : false;
        };

        $scope.deleteThumbnail = function() {
            delete $scope.thumbnailContainer.thumbnail;
            $scope.setDirty();
        };

        $scope.chooseThumbnail = function() {
            IhhMedia.chooseThumbnail($scope.getThumbnailResource(), 'Select Image', 'Select an image for the ' + $scope.personCategory, function(name) {
                $scope.setDirty();
                if (angular.isUndefined($scope.thumbnailContainer)) {
                    $scope.thumbnailContainer = {};
                }
                $scope.thumbnailContainer.thumbnail = name;
            }, function(err) {
                RestResources.reportRestError('Could not upload image', err);
            });
        };

        $scope.getRelationship = function(person) {
            return person;
        };

        $scope.rolesGetterSetter = function(role) {
            return function(nowHasRole) {
                if (nowHasRole !== undefined) {
                    // setter
                    var relationship = $scope.getRelationship($scope.personEdit);
                    if (!Utilities.isDefinedAndNotNull(relationship.roles)) {
                        relationship.roles = [];
                    }
                    var indexOfRole = relationship.roles.indexOf(role);
                    var didHaveRole = (indexOfRole !== -1);
                    var mustAdd = (!didHaveRole && nowHasRole);
                    var mustDel = (didHaveRole && !nowHasRole);
                    if (mustAdd) {
                        relationship.roles.push(role);
                    }
                    if (mustDel) {
                        relationship.roles.splice(indexOfRole, 1);
                    }
                }
                else {
                    //getter
                    return $scope.getRole(role);
                }
            };
        };

        $scope.getRole = function(role) {
            var indexOfRole;
            var relationship;
            if ($scope.editFlag) {
                if ($scope.personEdit) {
                    relationship = $scope.getRelationship($scope.personEdit);
                    if (relationship) {
                        if (!Utilities.isDefinedAndNotNull(relationship.roles)) {
                            relationship.roles = [];
                        }
                        indexOfRole = relationship.roles.indexOf(role);
                    }
                }
            }
            else if ($scope.person) {
                relationship = $scope.getRelationship($scope.person);
                if (relationship) {
                    if (!Utilities.isDefinedAndNotNull(relationship.roles)) {
                        relationship.roles = [];
                    }
                    indexOfRole = relationship.roles.indexOf(role);
                }
            }
            if (indexOfRole >= 0) {
                return true;
            }
            else {
                return false;
            }
        };

        $scope.toggleAllRoles = function() {
            var relationship = $scope.getRelationship($scope.personEdit);
            if (!Utilities.isDefinedAndNotNull(relationship.roles)) {
                relationship.roles = [];
            }
            var hasAllRoles = relationship.roles.length === $scope.roles.length;
            relationship.roles.splice(0, relationship.roles.length);
            if (!hasAllRoles) {
                for (var i = 0; i < $scope.roles.length; i++) {
                    relationship.roles.push($scope.roles[i].value);
                }
            }
            $scope.setDirty();
        };
    }
})();